import {useEffect, useState} from "react";
// Custom Components
import AchieveImage from "../../components/achieveImage";
import GameInfoBox from "../../components/gameInfoBox";
import SecondaryHeader from "../../components/secondaryHeader";

import splashMusic from "../../assets/sound/splash.mp3";

// Styles
import "./styles.scss";

function Welcome() {
  useEffect(() => {
    const audioEl = document.getElementsByClassName("audio-hide")[0];
    // audioEl.play();
  }, []);

  return (
    <section className="home-page-container bg-primary">
      <SecondaryHeader />

      <AchieveImage />

      <GameInfoBox level="60" time="3" />

      <audio controls loop className="audio-hide">
        <source src={splashMusic} type="audio/mp3" />
      </audio>
    </section>
  );
}

export default Welcome;
